let availableDatesApiEndpoint = "https://mankai-backoffice.developmankai.com/api/available-dates"; // no trailing slash
let shabatTimeApiEndpoint = "https://mankai-backoffice.developmankai.com/api/shabat-time/";
let lightDeliveryIconURL = "//mankai-hinoman.myshopify.com/cdn/shop/files/light-green-delivery.png?v=1742390256";
let darkDeliveryIconURL = "//mankai-hinoman.myshopify.com/cdn/shop/files/dark-green-delivery.png?v=1742390158";
let deliveryUnreachableText = "נראה שהמשלוחים שלנו עדיין לא מגיעים ליישוב שלך.\nאפשר למצוא את מנקאי ברשתות ובחנויות הטבע ברחבי הארץ."
const customSupportedCities = [
  "כפר האורנים",
  "גני הדר",
  "מודיעין עילית",
  "מחנה הילה",
  "צור יגאל",
  "גבעת עדה",
  "נעורים",
  "יקנעם המושבה",
  "מבוא מודיעין",
  "מקווה ישראל",
  "צופיה",
  "גבעת חיים",
  "קרית חיים",
  "פרדס חנה",
  "כפר אז\"ר",
  "כפר אזר",
  "כפר מהרל",
  "כפר מהר\"ל",
  "קיבוץ אייל",
  "נווה מונוסון"
];

const bara_specific_items = [
    "אבקת מנקאי 100% ירק טבעי",
    "מנקאי טבעי בכמוסות",
    "שיגרה ירוקה"
];

// ── Cart interceptors ─────────────────────────────────────────────────────────

(function () {
    const _origFetch = window.fetch;
    window.fetch = function (input, init) {
        const url = typeof input === "string" ? input : (input instanceof Request ? input.url : "");
        if (url.includes("cart/add") && !window._ourCartAdd) {
            return _origFetch(input, init).then(async response => {
                if (response.ok) {
                    try { handleAfterCartAdd(await response.clone().json()); } catch (e) { console.error("[delivery] handleAfterCartAdd error", e); }
                }
                return response;
            });
        }
        if ((url.includes("cart/change") || url.includes("cart/clear") || url.includes("cart/update")) && !window._ourCartChange) {
            return _origFetch(input, init).then(async response => {
                if (response.ok) {
                    try { handleAfterCartChange(await response.clone().json()); } catch (e) { console.error("[delivery] handleAfterCartChange error", e); }
                }
                return response;
            });
        }
        return _origFetch(input, init);
    };

    const _origOpen = XMLHttpRequest.prototype.open;
    const _origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
        this._deliveryUrl = typeof url === "string" ? url : "";
        return _origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
        const url = this._deliveryUrl || "";
        const isCartAdd = url.includes("cart/add") && !window._ourCartAdd;
        const isCartChange = (url.includes("cart/change") || url.includes("cart/clear") || url.includes("cart/update")) && !window._ourCartChange;
        if (isCartAdd) {
            this.addEventListener("load", function () {
                if (this.status >= 200 && this.status < 300) {
                    try { handleAfterCartAdd(JSON.parse(this.responseText)); } catch (e) { console.error("[delivery] XHR handleAfterCartAdd error", e); }
                }
            });
        }
        if (isCartChange) {
            this.addEventListener("load", function () {
                if (this.status >= 200 && this.status < 300) {
                    try { handleAfterCartChange(JSON.parse(this.responseText)); } catch (e) { console.error("[delivery] XHR handleAfterCartChange error", e); }
                }
            });
        }
        return _origSend.apply(this, arguments);
    };
})();

// ── Date helpers ──────────────────────────────────────────────────────────────

// YYYY-MM-DD  →  dd.mm.YYYY
function isoToDisplay(isoDate) {
    const [year, month, day] = isoDate.split("-");
    return `${day}.${month}.${year}`;
}

// dd.mm.YYYY  →  YYYY-MM-DD
function displayToISO(displayDate) {
    const ddMmYyyyRegex = /^\d{2}\.\d{2}\.\d{4}$/;
    if (ddMmYyyyRegex.test(displayDate)) {
        const [day, month, year] = displayDate.split(".");
        return `${year}-${month}-${day}`;
    }
    return displayDate; // already ISO or unknown format
}

// YYYY-MM-DD  →  "יום שני" etc.
function getDayNameHebrew(isoDate) {
    const daysOfWeekHe = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];
    // Parse without timezone shift: treat YYYY-MM-DD as local date
    const [year, month, day] = isoDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return `יום ${daysOfWeekHe[date.getDay()]}`;
}

function convertDateFormat(dateStr) {
    const ddMmYyyyRegex = /^\d{2}\.\d{2}\.\d{4}$/;
    if (ddMmYyyyRegex.test(dateStr)) {
        const [day, month, year] = dateStr.split(".");
        return `${year}-${month}-${day}`;
    }
    return dateStr;
}

function convertDateFormatDisplay(dateStr) {
    const ddMmYyyyRegex = /^\d{4}\.\d{2}\.\d{2}$/;
    if (ddMmYyyyRegex.test(dateStr)) {
        const [year, month, day] = dateStr.split("-");
        return `${day}.${month}.${year}`;
    }
    return dateStr;
}

// ── Event listeners ───────────────────────────────────────────────────────────

// hide the unnecessary multicolumn at dry mankai without affecting other pages
document.addEventListener('DOMContentLoaded', function() {
  const section = document.getElementById('shopify-section-template--19326025334851__multicolumn_bN37Wq');
  if (section) section.style.display = 'none';
});

function updateDeliveryButtonVisibility() {
    const storedCity = sessionStorage.getItem("selectedCity");
    const storedDate = sessionStorage.getItem("selectedDate");
    const show = (storedCity && storedDate) ? "flex" : "none";

    document.querySelectorAll("button[name='open-delivery-popup-btn-desktop']").forEach(btn => {
        btn.style.display = show;
    });

    document.querySelectorAll("button.mobile-only").forEach(btn => {
        btn.style.display = show;
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const cityInput = document.getElementById("delivery-popup-city-search");
    const checkButton = document.querySelector(".check-btn");
    const container = document.querySelector(".delivery-popup-input-container");

    checkButton.addEventListener("click", function () {
        this.blur();
    });

    document.addEventListener("click", function (event) {
        if (!container.contains(event.target)) {
            container.classList.remove("focused");
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    loadGooglePlacesAPI();
    updateDeliveryButtonText();
    updateDeliveryButtonVisibility();
    checkBaraOnlyCart();
    checkIsShabbat().then(isShabbat => {
        if (!isShabbat) return;
        fetch('/cart.js').then(r => r.json()).then(cart => {
            if (!cart.items || cart.items.length === 0) return;
            window._ourCartChange = true;
            fetch('/cart/clear.js', { method: 'POST' })
                .catch(() => {})
                .finally(() => { window._ourCartChange = false; refreshCartUI(); });
            openShabatPopup();
        }).catch(() => {});
    });

    if (sessionStorage.getItem("openCartAfterReload") === "true") {
        sessionStorage.removeItem("openCartAfterReload");
        openCartDrawer();
    }

    document.addEventListener("click", function (event) {
        let addToCartButton = event.target.closest("[add-to-cart-button='true'], [name='add']");

        if (addToCartButton) {
            event.preventDefault();
            addProductToCart(addToCartButton.closest("form"));
        }
    });

    var checkoutButton = document.querySelector("button[name='checkout']");

    if (checkoutButton) {
        checkoutButton.addEventListener("click", async function (event) {
            event.preventDefault();

            const isShabbat = await checkIsShabbat();
            if (isShabbat) {
                window._ourCartChange = true;
                try { await fetch('/cart/clear.js', { method: 'POST' }); } catch (e) {}
                window._ourCartChange = false;
                openShabatPopup();
                refreshCartUI();
                return;
            }

            var selectedCity = sessionStorage.getItem("selectedCity");
            var selectedDate = sessionStorage.getItem("selectedDate");

            if (!selectedCity || !selectedDate) {
                try {
                    const cartResp = await fetch("/cart.js");
                    if (cartResp.ok) {
                        const cart = await cartResp.json();
                        const items = cart.items || [];
                        const hasNonBara = items.some(i => !bara_specific_items.includes((i.product_title || "").trim()));
                        if (!hasNonBara) {
                            window.location.href = "/cart/checkout";
                            return;
                        }
                    }
                } catch (err) {
                    // Network error — fall through to popup.
                }
                openPopup();
                return;
            }

            let notAvailableMessage = document.getElementById("delivery-popup-not-available-message");

            try {
                const resp = await fetch(`${availableDatesApiEndpoint}/${encodeURIComponent(selectedCity)}/`);
                if (resp.ok) {
                    const data = await resp.json();
                    const availableDates = data.available_dates || [];
                    const isoDate = displayToISO(selectedDate);
                    if (!availableDates.includes(isoDate)) {
                        openPopup();
                        notAvailableMessage.style.display = "block";
                        notAvailableMessage.textContent = `אוי, נראה שכל המשלוחים לישוב זה בתאריך ${selectedDate} כבר נתפסו. אנא בחרו תאריך משלוח חדש`;
                        return;
                    }
                }
            } catch (err) {
                // Network error — proceed to checkout optimistically.
            }

            var checkoutURL = "/cart/checkout?" +
                "checkout[shipping_address][city]=" + encodeURIComponent(sessionStorage.getItem("selectedCity"))
                + "&checkout[attributes][Delivery Date]=" + encodeURIComponent(sessionStorage.getItem("selectedDate"))
                + "&checkout[shipping_address][delivery_date]=" + encodeURIComponent(sessionStorage.getItem("selectedDate"));

            window.location.href = checkoutURL;
        });
    }
});

// ── Cart helpers ──────────────────────────────────────────────────────────────

async function updateCartAttribute(attributes) {
    window._ourCartChange = true;
    try {
        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
        });
        if (!response.ok) throw new Error("Failed to update cart attributes");
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error updating cart attributes:", error);
        throw error;
    } finally {
        window._ourCartChange = false;
    }
}

function updateDeliveryNote(appendText) {
    return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const currentNote = cart.note || "";
            if (currentNote.includes(appendText)) {
                console.log("⏩ Note already contains delivery info, skipping update.");
                return { updated: false, reason: "already exists" };
            }
            const newNote = currentNote.trim() + (currentNote.trim() ? "\n" : "") + appendText;
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ note: newNote }),
            });
        })
        .then(response => {
            if (response && response.ok) {
                console.log("✅ Note appended to Shopify cart.");
                return { updated: true };
            } else {
                console.warn("⚠️ Failed to update cart note.");
                return { updated: false };
            }
        })
        .catch(error => {
            console.error("❌ Failed to append to cart note:", error);
            return { updated: false, error };
        });
}

function handleAfterCartChange(cart) {
    const items = cart.items || [];
    const storedCity = sessionStorage.getItem("selectedCity");
    const storedDate = sessionStorage.getItem("selectedDate");
    if (!storedCity || !storedDate) return;
    const hasNonBara = items.some(i => !bara_specific_items.includes((i.product_title || "").trim()));
    if (hasNonBara) return;

    sessionStorage.removeItem("selectedCity");
    sessionStorage.removeItem("selectedDate");
    updateCartAttribute({ "selected_delivery_date": "", "selected_delivery_city": "" });
    updateDeliveryButtonVisibility();
    if (items.length > 0) openBaraPopup();
}

function handleAfterCartAdd(addedData) {
    const popup = document.getElementById("delivery-popup");
    if (popup?.style.display === "block") return;

    const storedCity = sessionStorage.getItem("selectedCity");
    const storedDate = sessionStorage.getItem("selectedDate");
    if (storedCity && storedDate) return;

    const items = addedData.items || [addedData];
    const hasNonBara = items.some(i => !bara_specific_items.includes((i.product_title || "").trim()));
    if (!hasNonBara) return;

    window._pendingCartItemKeys = items.map(i => i.key);
    openPopup();
}

function openBaraPopup() {
    const popup = document.getElementById("delivery-popup-bara-items-only");
    if (popup) popup.style.display = "block";
}

function closeBaraPopup() {
    const popup = document.getElementById("delivery-popup-bara-items-only");
    if (popup) popup.style.display = "none";
}

function openShabatPopup() {
    const popup = document.getElementById("delivery-popup-shabat-time");
    if (popup) popup.style.display = "block";
}

async function refreshCartUI() {
    try {
        const resp = await fetch('/cart.js');
        const cart = await resp.json();
        const count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = count;
            el.setAttribute('data-cart-count', count);
        });
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
}

function closeShabatPopup() {
    const popup = document.getElementById("delivery-popup-shabat-time");
    if (popup) popup.style.display = "none";
}

async function checkIsShabbat() {
    try {
        const resp = await fetch(shabatTimeApiEndpoint);
        if (!resp.ok) return false;
        const data = await resp.json();
        const now = new Date();
        const cutoff = new Date(new Date(data.shabbat_start).getTime() - 15 * 60 * 1000);
        const shabbatEnd = new Date(new Date(data.shabbat_end).getTime() + 15 * 60 * 1000);
        return now >= cutoff && now < shabbatEnd;
    } catch (e) {
        return false;
    }
}

function checkBaraOnlyCart() {
    const storedCity = sessionStorage.getItem("selectedCity");
    const storedDate = sessionStorage.getItem("selectedDate");
    if (!storedCity || !storedDate) return;

    fetch("/cart.js")
        .then(r => r.json())
        .then(cart => {
            const items = cart.items || [];
            if (items.length === 0) return;
            const hasNonBara = items.some(i => !bara_specific_items.includes(i.product_title.trim()));
            if (hasNonBara) return;

            sessionStorage.removeItem("selectedCity");
            sessionStorage.removeItem("selectedDate");
            updateCartAttribute({ "selected_delivery_date": "", "selected_delivery_city": "" });
            updateDeliveryButtonVisibility();
            if (items.length > 0) openBaraPopup();
        })
        .catch(() => {});
}

// ── Delivery button ───────────────────────────────────────────────────────────

function updateDeliveryButtonText() {
    let selectedCity = sessionStorage.getItem("selectedCity");
    let selectedDate = sessionStorage.getItem("selectedDate");
    let lightDeliverySpans = document.querySelectorAll("span[name='open-delivery-popup-btn-span-light-desktop']");
    let darkDeliverySpans = document.querySelectorAll("span[name='open-delivery-popup-btn-span-dark-desktop']");

    let formattedDate = convertDateFormat(selectedDate);
    let dateObj = new Date(formattedDate);
    let selectedDateName = dateObj.toLocaleDateString("he-IL", { weekday: "long" });

    if (selectedCity && selectedDate) {
        let lightDeliveryIcon = `<img src="${lightDeliveryIconURL}" width="23px" height="23px" alt="Delivery Icon" class="delivery-popup-icon">`;
        let darkDeliveryIcon = `<img src="${darkDeliveryIconURL}" width="23px" height="23px" alt="Delivery Icon" class="delivery-popup-icon">`;
        let newText = `${selectedDateName} ${selectedDate}, ${selectedCity}`;

        lightDeliverySpans.forEach(span => { span.innerHTML = `${lightDeliveryIcon} ${newText}`; });
        darkDeliverySpans.forEach(span => { span.innerHTML = `${darkDeliveryIcon} ${newText}`; });
    }
}

// ── Google Places ─────────────────────────────────────────────────────────────

function loadGooglePlacesAPI() {
    if (window.google && window.google.maps) {
        initGooglePlacesAutocomplete();
        return;
    }
    let script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${window.GoogleConfig.apiKey}&libraries=places&language=he&region=IL&callback=initGooglePlacesAutocomplete`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
}

function openPopup() {
    let popup = document.getElementById("delivery-popup");
    let selectedCity = document.getElementById("delivery-popup-city-search");
    let storedCity = sessionStorage.getItem("selectedCity");
    let storedDate = sessionStorage.getItem("selectedDate");
    let openingTextSection = document.getElementById("delivery-popup-opening-text");

    if (popup) {
        popup.style.display = "block";
        openingTextSection.style.display = "block";

        if (selectedCity && storedDate && storedCity) {
            selectedCity.value = storedCity;
            checkCity();
        }
    } else {
        console.error("❌ Delivery Popup not found. Check your HTML.");
    }
}

function initGooglePlacesAutocomplete() {
    let input = document.getElementById("delivery-popup-city-search");
    if (!input) return;

    let autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["(cities)"],
        componentRestrictions: { country: "IL" }
    });

    input.addEventListener("input", () => {
        const query = input.value.trim();
        const pacContainer = document.querySelector(".pac-container");

        const existingCustomItems = document.querySelectorAll(".pac-item.custom-city");
        existingCustomItems.forEach(item => item.remove());

        if (!query || !pacContainer) return;

        const matches = customSupportedCities.filter(city => city.includes(query));
        if (matches.length === 0) return;

        matches.forEach(city => {
            const item = document.createElement("div");
            item.className = "pac-item custom-city";

            const icon = document.createElement("span");
            icon.className = "pac-icon pac-icon-marker";

            const textWrapper = document.createElement("div");
            textWrapper.className = "pac-item-query";
            const matchIndex = city.indexOf(query);
            if (matchIndex >= 0) {
                const before = city.slice(0, matchIndex);
                const match = city.slice(matchIndex, matchIndex + query.length);
                const after = city.slice(matchIndex + query.length);
                textWrapper.innerHTML = `${before}<strong>${match}</strong>${after}`;
            } else {
                textWrapper.textContent = city;
            }

            item.appendChild(icon);
            item.appendChild(textWrapper);
            item.style.cursor = "pointer";
            item.addEventListener("mousedown", (e) => {
                e.preventDefault();
                e.stopPropagation();
                input.value = city;
                input.blur();
                const pacContainer = document.querySelector(".pac-container");
                if (pacContainer) pacContainer.style.display = "none";
            });

            pacContainer.appendChild(item);
        });
    });

    setTimeout(() => {
        const style = document.createElement("style");
        style.innerHTML = `
            .pac-container {
                font-family: Arial, sans-serif !important;
                font-size: 16px !important;
                text-align: right;
                direction: rtl;
                border-radius: 8px;
                border: 1px solid #1E392A;
                background: white;
                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
            }
            .pac-item {
                font-size: 16px !important;
                padding: 10px !important;
                color: #1E392A !important;
                display: flex;
                align-items: center;
            }
            .pac-item.custom-city .pac-icon {
                background-image: url('https://cdn.shopify.com/s/files/1/0598/2575/0083/files/Geocode-Icon.png?v=1748699164');
                background-size: 15px 20px;
                background-repeat: no-repeat;
                background-position: center;
                width: 15px;
                height: 20px;
                margin-inline-end: 7px;
                flex-shrink: 0;
            }
            .pac-item.custom-city .pac-item-query { flex-grow: 1; }
            .pac-container:after { content: none !important; display: none !important; }
        `;
        document.head.appendChild(style);
    }, 500);

    document.addEventListener("click", function (e) {
        const customDropdown = document.getElementById("custom-google-extension");
        if (customDropdown && !customDropdown.contains(e.target) && e.target !== input) {
            customDropdown.remove();
        }
    });

    autocomplete.addListener("place_changed", function () {
        const place = autocomplete.getPlace();

        if (!place.geometry) {
            let notAvailableMessage = document.getElementById("delivery-popup-not-available-message");
            notAvailableMessage.style.display = "block";
            notAvailableMessage.textContent = "נא לבחור עיר מהרשימה";
            return;
        }

        const inputField = document.getElementById("delivery-popup-city-search");
        const userInput = inputField.value.trim();

        if (userInput === "בנימינה גבעת עדה") {
            inputField.value = "גבעת עדה";
            return;
        }

        const hebrewRegex = /[\u0590-\u05FF]/;
        if (hebrewRegex.test(userInput)) {
            inputField.value = userInput;
            return;
        }

        const hebrewCityComponent = place.address_components.find(comp =>
            comp.types.includes("locality") && hebrewRegex.test(comp.long_name)
        );

        inputField.value = hebrewCityComponent ? hebrewCityComponent.long_name : place.name;
    });

    setTimeout(() => {
        const pacContainer = document.querySelector(".pac-container");
        if (pacContainer) {
            pacContainer.style.zIndex = "999999";
            pacContainer.style.position = "absolute";
            document.body.appendChild(pacContainer);
        }
    }, 500);
}

// ── Popup UI ──────────────────────────────────────────────────────────────────

function closePopup() {
    if (window._pendingCartItemKeys?.length) {
        const keys = window._pendingCartItemKeys;
        window._pendingCartItemKeys = null;
        window._ourCartChange = true;
        Promise.all(keys.map(key =>
            fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: key, quantity: 0 })
            })
        )).then(() => { window._ourCartChange = false; location.reload(); })
          .catch(() => { window._ourCartChange = false; location.reload(); });
        return;
    }

    let popup = document.getElementById("delivery-popup");
    let citySearchInput = document.getElementById("delivery-popup-city-search");
    let notAvailableMessage = document.getElementById("delivery-popup-not-available-message");
    let resultSection = document.getElementById("delivery-popup-city-check-result");
    let saveButton = document.getElementById("delivery-popup-save-btn");
    let deliveryDateContainer = document.getElementById("delivery-popup-date-container");

    if (!popup) return;

    popup.style.display = "none";
    if (citySearchInput) citySearchInput.value = "";
    if (notAvailableMessage) { notAvailableMessage.style.display = "none"; notAvailableMessage.textContent = ""; }
    if (resultSection) resultSection.style.display = "none";
    if (saveButton) saveButton.style.display = "none";
    if (deliveryDateContainer) deliveryDateContainer.innerHTML = "";
}

// ── Core: check city via API ──────────────────────────────────────────────────

async function checkCity() {
    let selectedCityInput = document.getElementById("delivery-popup-city-search");
    let resultSection = document.getElementById("delivery-popup-city-check-result");
    let openingTextSection = document.getElementById("delivery-popup-opening-text");
    let saveButton = document.getElementById("delivery-popup-save-btn");
    let notAvailableMessage = document.getElementById("delivery-popup-not-available-message");
    let deliveryDateContainer = document.getElementById("delivery-popup-date-container");
    let storedCity = sessionStorage.getItem("selectedCity");
    let storedDate = sessionStorage.getItem("selectedDate");

    if (!selectedCityInput || !resultSection || !saveButton || !notAvailableMessage || !deliveryDateContainer) {
        console.error("❌ Missing elements in checkCity(). Check your HTML IDs.");
        return;
    }

    // Reset UI
    resultSection.style.display = "none";
    saveButton.style.display = "none";
    notAvailableMessage.style.display = "none";
    notAvailableMessage.textContent = "";
    deliveryDateContainer.innerHTML = "";

    let cityName = selectedCityInput.value.trim();
    if (!cityName) {
        notAvailableMessage.style.display = "block";
        notAvailableMessage.textContent = "נא לבחור עיר מהרשימה";
        return;
    }

    // Call the API
    let response;
    try {
        response = await fetch(`${availableDatesApiEndpoint}/${encodeURIComponent(cityName)}/`);
    } catch (err) {
        console.error("❌ Network error fetching delivery dates:", err);
        notAvailableMessage.style.display = "block";
        notAvailableMessage.textContent = "שגיאת רשת. אנא נסו שוב.";
        return;
    }

    if (!response.ok) {
        // City not found or no available dates
        notAvailableMessage.style.display = "block";
        notAvailableMessage.textContent = deliveryUnreachableText;
        return;
    }

    const data = await response.json();
    const isoDates = data.available_dates; // ["YYYY-MM-DD", ...]

    if (!isoDates || isoDates.length === 0) {
        notAvailableMessage.style.display = "block";
        notAvailableMessage.textContent = "מתנצלים, לא נותרו תאריכי משלוח לעיר זו כרגע.";
        return;
    }

    // Show zone message if present
    if (data.zone_message) {
        notAvailableMessage.style.display = "block";
        notAvailableMessage.textContent = data.zone_message;
    }

    // Render date options
    resultSection.style.display = "block";
    openingTextSection.style.display = "none";

    isoDates.forEach((isoDate, index) => {
        let displayDate = isoToDisplay(isoDate);  // dd.mm.YYYY
        let dayName = getDayNameHebrew(isoDate);  // "יום שני"

        let option = document.createElement("div");
        option.classList.add("delivery-popup-date-option");
        option.innerHTML = `<strong>${dayName}</strong><br>${displayDate}`;
        option.dataset.value = displayDate;
        option.onclick = function () { selectDate(this); };

        if (!storedDate || storedCity !== cityName) {
            if (index === 0) option.classList.add("selected");
        } else {
            if (displayDate === storedDate) option.classList.add("selected");
        }

        deliveryDateContainer.appendChild(option);
    });

    saveButton.style.display = "block";
    return true;
}

function selectDate(element) {
    document.querySelectorAll('.delivery-popup-date-option').forEach(date => date.classList.remove('selected'));
    element.classList.add('selected');
}


// ── Save ──────────────────────────────────────────────────────────────────────

async function saveDeliveryInfo() {
    let selectedCity = document.getElementById("delivery-popup-city-search").value;
    let selectedDateElement = document.querySelector(".delivery-popup-date-option.selected");
    let selectedDate = selectedDateElement ? selectedDateElement.dataset.value : null;
    let notAvailableMessage = document.getElementById("delivery-popup-not-available-message");

    if (!selectedCity || !selectedDate) {
        notAvailableMessage.style.display = "block";
        notAvailableMessage.textContent = "נא לבחור עיר ותאריך משלוח.";
        return;
    }

    if (!selectedDateElement) {
        notAvailableMessage.style.display = "block";
        notAvailableMessage.textContent = "שיניתם את היעד? לחצו שוב על כפתור הבחירה לרענון.";
        return;
    }

    try {
        await updateCartAttribute({
            "selected_delivery_date": selectedDate,
            "selected_delivery_city": selectedCity
        });

        sessionStorage.setItem("selectedCity", selectedCity);
        sessionStorage.setItem("selectedDate", selectedDate);
        window._pendingCartItemKeys = null;

        updateDeliveryButtonText();
        closePopup();

        sessionStorage.setItem("openCartAfterReload", "true");
        location.reload();
    } catch (err) {
        console.error("❌ Failed to save delivery info:", err);
        alert("שגיאה בשמירת מידע המשלוח. נסה שוב.");
    }
}

// ── Cart / checkout ───────────────────────────────────────────────────────────

async function addProductToCart(addToCartForm) {
    const isShabbat = await checkIsShabbat();
    if (isShabbat) {
        window._ourCartChange = true;
        try { await fetch('/cart/clear.js', { method: 'POST' }); } catch (e) {}
        window._ourCartChange = false;
        openShabatPopup();
        refreshCartUI();
        return;
    }

    let formData = new FormData(addToCartForm);
    let postData = new URLSearchParams();
    for (let pair of formData.entries()) {
        postData.append(pair[0], pair[1]);
    }

    window._ourCartAdd = true;
    fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: postData
    })
    .then(response => response.json())
    .then(data => {
        const popupOpened = !!window._pendingCartItemKeys;
        handleAfterCartAdd(data);
        if (!window._pendingCartItemKeys && !popupOpened) {
            sessionStorage.setItem("openCartAfterReload", "true");
            location.reload();
        }
    })
    .catch(error => {
        console.error("❌ Failed to add product:", error);
        alert("אירעה שגיאה בעת הוספת המוצר לעגלה. נסה שוב.");
    })
    .finally(() => { window._ourCartAdd = false; });
}

function openCartDrawer() {
    let cartDrawerTrigger = document.querySelector("[class*='cart-drawer-button']");
    if (cartDrawerTrigger) {
        let cartDrawer = document.querySelector(".cart-drawer");
        if (cartDrawer && !cartDrawer.classList.contains("is-open")) {
            cartDrawerTrigger.click();
        }
    } else {
        console.warn("⚠ No cart drawer button found. Check your selector.");
    }
}
